<template>
    <div class="border-separation"></div>
</template>

<script type="plain/text">
export default {

}
</script>
